import { actionTypes } from "./designationActionTypes";

const normalize = (row) => {
  if (!row || typeof row !== "object") return row;
  return {
    ...row,
    id: row.id ?? row.Id,
    name: row.name ?? row.Name,
    notes: row.notes ?? row.Notes,
    isActive: row.isActive !== undefined ? row.isActive : row.IsActive,
    createdDate: row.createdDate ?? row.CreatedDate,
    userCount: (() => {
      const c =
        row.userCount ??
        row.UserCount ??
        row.associatedEmployeeCount ??
        row.AssociatedEmployeeCount;
      if (c === undefined || c === null) return undefined;
      return Number(c);
    })(),
  };
};

const INITIAL_STATE = {
  record: [],
  isLoading: false,
  Error: false,
  message: "",
};

export default function designationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.DG_LOADING_START:
      return { ...state, isLoading: true, message: "" };
    case actionTypes.DG_LOADING_STOP:
      return { ...state, isLoading: false, message: "" };
    case actionTypes.DG_SHOW_LIST:
      return {
        ...state,
        Error: false,
        record: Array.isArray(action.payload)
          ? action.payload.map(normalize)
          : [],
        isLoading: false,
      };
    case actionTypes.DG_ADD_SUCCESS: {
      const row = normalize(action.payload);
      return {
        ...state,
        Error: false,
        isLoading: false,
        record: [...state.record, row],
      };
    }
    case actionTypes.DG_UPDATE_SUCCESS: {
      const row = normalize(action.payload);
      const id = row.id;
      return {
        ...state,
        Error: false,
        isLoading: false,
        record: state.record.map((r) =>
          r.id === id ? { ...r, ...row } : r
        ),
      };
    }
    case actionTypes.DG_DELETE_SOFT: {
      const target = action.payload;
      const id = target.id ?? target.Id;
      return {
        ...state,
        Error: false,
        isLoading: false,
        record: state.record.map((r) =>
          r.id === id ? { ...r, isActive: false } : r
        ),
      };
    }
    default:
      return state;
  }
}
